import { Column } from "components/grid/column";
import React from "react";
import { Heading, Text } from "spectacle";

export const S31 = () => (
  <>
    <Column paddingBottom={48}>
      <Text lineHeight={1} textColor="secondary">
        Problem #1
      </Text>
    </Column>

    <Heading size={2}>Fog of war</Heading>
  </>
);
